import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzPpday80 } from './pages'

type TIdToPageMapWoofzPpday80 = Record<PageIdWoofzPpday80, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_PPDAY_80: TIdToPageMapWoofzPpday80 = {
  [PageId.SUBSCRIPTIONS_PPDAY_80_N]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_80/pages/subscriptions/SubscriptionPpday80'
      ).then((m) => ({
        default: m.SubscriptionsPpday80,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_80/pages/subscriptions/SubscriptionPpday80'
      ),
  },
  [PageId.CHAT_UPSELL_PPDAY_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_80/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_80/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_PPDAY_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_80/pages/upsell/Upsell'
      ).then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ppday/woofz_ppday_80/pages/upsell/Upsell'),
  },
  [PageIdWoofzPpday80.DOWNLOAD_PPDAY_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_80/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ppday/woofz_ppday_80/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzPpday80.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
